import { forEach } from 'lodash'
import colors from 'vuetify/lib/util/colors'

export default {
  computed: {
    themeColorName () {
      return this.getThemeColorName(this.color.split(' '))
    },
    baseColorName () {
      return this.getBaseColorName(this.color.split(' '))
    },
    colorVariantName () {
      return this.getColorVariantName(this.color.split(' '))
    },
    hexColor () {
      return this.getHexColor(this.themeColorName, this.baseColorName, this.colorVariantName)
    },
    textClasses () {
      const classes = {}
      if (this.themeColorName) {
        classes[`${this.themeColorName}--text`] = true
      } else {
        classes[`${this.baseColorName}--text`] = true
        if (this.colorVariantName) {
          classes[`text--${this.colorVariantName}`] = true
        }
      }
      return classes
    },
    backgroundClasses () {
      const classes = {}
      classes[this.color] = true
      return classes
    }
  },
  methods: {
    getThemeColorName (colorArr) {
      let name
      forEach(colorArr, color => {
        if (this.$vuetify.theme[color]) {
          name = color
        }
      })
      return name
    },
    getBaseColorName (colorArr) {
      let name
      forEach(colorArr, color => {
        if (colors[color]) {
          name = color
        }
      })
      return name
    },
    getColorVariantName (colorArr) {
      let name
      forEach(colorArr, color => {
        if (color.indexOf('darken') !== -1) {
          name = color
        }
        if (color.indexOf('ligthen') !== -1) {
          name = color
        }
      })
      return name
    },
    getHexColor (themeColorName, baseColorName, colorVariantName) {
      if (themeColorName) {
        return this.$vuetify.theme[themeColorName]
      } else {
        if (colorVariantName && baseColorName) {
          return colors[baseColorName][colorVariantName.replace('-', '')]
        } else if (baseColorName) {
          return colors[baseColorName].base
        }
      }
    },
    getHexColorFromColor (color) {
      return this.getHexColor(this.getThemeColorName(color.split(' ')), this.getBaseColorName(color.split(' ')), this.getColorVariantName(color.split(' ')))
    }
  }
}
